import { HappyMammaService } from '@hm_app/@core/data/happymamma.service';

import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NbComponentStatus, NbGlobalLogicalPosition, NbToastrService } from '@nebular/theme';


@Component({
    templateUrl: './hm-reset-password-component.html',
    styleUrls: ['./hm-reset-password-component.css'],
    selector: 'hm-reset-password-page',
    // styles: [":host .links{display:flex;justify-content:space-between}:host .form-group:last-of-type{margin-bottom:3rem} "],
    // template: "\n    <nb-auth-block>\n      <h2 class=\"title\">Change password</h2>\n      <small class=\"form-text sub-title\">Please enter a new password</small>\n      <form (ngSubmit)=\"resetPass()\" #resetPassForm=\"ngForm\">\n\n        <div *ngIf=\"errors && errors.length > 0 && !submitted\" class=\"alert alert-danger\" role=\"alert\">\n          <div><strong>Oh snap!</strong></div>\n          <div *ngFor=\"let error of errors\">{{ error }}</div>\n        </div>\n        <div *ngIf=\"messages && messages.length > 0 && !submitted\" class=\"alert alert-success\" role=\"alert\">\n          <div><strong>Hooray!</strong></div>\n          <div *ngFor=\"let message of messages\">{{ message }}</div>\n        </div>\n\n        <div class=\"form-group\">\n          <label for=\"input-password\" class=\"sr-only\">New Password</label>\n          <input name=\"password\" [(ngModel)]=\"user.password\" type=\"password\" id=\"input-password\"\n                 class=\"form-control form-control-lg first\" placeholder=\"New Password\" #password=\"ngModel\"\n                 [class.form-control-danger]=\"password.invalid && password.touched\"\n                 [required]=\"getConfigValue('forms.validation.password.required')\"\n                 [minlength]=\"getConfigValue('forms.validation.password.minLength')\"\n                 [maxlength]=\"getConfigValue('forms.validation.password.maxLength')\"\n                 autofocus>\n          <small class=\"form-text error\" *ngIf=\"password.invalid && password.touched && password.errors?.required\">\n            Password is required!\n          </small>\n          <small\n            class=\"form-text error\"\n            *ngIf=\"password.invalid && password.touched && (password.errors?.minlength || password.errors?.maxlength)\">\n            Password should contains\n            from {{getConfigValue('forms.validation.password.minLength')}}\n            to {{getConfigValue('forms.validation.password.maxLength')}}\n            characters\n          </small>\n        </div>\n\n        <div class=\"form-group\">\n          <label for=\"input-re-password\" class=\"sr-only\">Confirm Password</label>\n          <input\n            name=\"rePass\" [(ngModel)]=\"user.confirmPassword\" type=\"password\" id=\"input-re-password\"\n            class=\"form-control form-control-lg last\" placeholder=\"Confirm Password\" #rePass=\"ngModel\"\n            [class.form-control-danger]=\"(rePass.invalid || password.value != rePass.value) && rePass.touched\"\n            [required]=\"getConfigValue('forms.validation.password.required')\">\n          <small class=\"form-text error\"\n                 *ngIf=\"rePass.invalid && rePass.touched && rePass.errors?.required\">\n            Password confirmation is required!\n          </small>\n          <small\n            class=\"form-text error\"\n            *ngIf=\"rePass.touched && password.value != rePass.value && !rePass.errors?.required\">\n            Password does not match the confirm password.\n          </small>\n        </div>\n\n        <button [disabled]=\"submitted || !resetPassForm.form.valid\" class=\"btn btn-hero-success btn-block\"\n                [class.btn-pulse]=\"submitted\">\n          Change password\n        </button>\n      </form>\n\n      <div class=\"links col-sm-12\">\n        <small class=\"form-text\">\n          Already have an account? <a routerLink=\"../login\"><strong>Sign In</strong></a>\n        </small>\n        <small class=\"form-text\">\n          <a routerLink=\"../register\"><strong>Sign Up</strong></a>\n        </small>\n      </div>\n    </nb-auth-block>\n  ",
})
export class HmResetPasswordComponent implements OnInit {

    resetted: boolean;
    code: string;
    user_password: string;
    user_confirmPassword: string;

    loading = false;

    // password_pattern = '^[a-z0-9A-Z]*$';

    // 8 caratteri, maiuscola, minuscola, cifra
    password_pattern = '^(?=.{8,}$)(?=.*[0-9])(?=.*?[a-z])(?=.*?[A-Z]).*$';

    get confirmedPassword(): boolean {
        return this.user_confirmPassword == this.user_password;
    }

	/*
	^ #Starting of string
   (?=.{10,}$) #Check there is at least 10 characters in the string.
			   #As this is lookahead the position of checking will reset to starting again
   (?=.*[a-z]) #Check if there is at least one lowercase in string.
			   #As this is lookahead the position of checking will reset to starting again
   (?=.*[A-Z]) #Check if there is at least one uppercase in string.
			   #As this is lookahead the position of checking will reset to starting again
   (?=.*[0-9]) #Check if there is at least one digit in string.
			   #As this is lookahead the position of checking will reset to starting again
   (?=.*\W) #Check if there is at least one special character in string.
			#As this is lookahead the position of checking will reset to starting again
  .*$ #Capture the entire string if all the condition of lookahead is met. This is not required if only validation is needed
  */


    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private hmService: HappyMammaService,
        private toastrService: NbToastrService,
    ) { }

    ngOnInit() {
        // Called after the constructor, initializing input properties, and the first call to ngOnChanges.
        // Add 'implements OnInit' to the class.
        this.code = this.activatedRoute.snapshot.queryParams['code'];
        // console.log(this.code);
    }

    resetPassword() {
        this.loading = true;
        this.hmService.resetPassword(this.code, this.user_password).subscribe(
            () => {
                this.loading = false;
                this.resetted = true;
                this.showToast(
                    'success',
                    'Password resettata',
                    null,
                );
                setTimeout(() => { this.router.navigate(['/auth/login']); }, 2000);
            },
            error => {
                const e = error.error;
                console.error(error);
                this.loading = false;

                let msg = 'Errore nel reset della password';
                if (e && e.message) {
                    msg = e.message;
                }
                this.showToast(
                    'danger',
                    msg,
                    null,
                );
            },
        );
    }
    private showToast(status: NbComponentStatus, title: string, body: string) {
        const position = NbGlobalLogicalPosition.BOTTOM_END;
        this.toastrService.show(body, title, { position, status} );
    }
}
